export const useBlockContainerName = (blockId: string) => {
  return `block/${blockId}`
}
